import { Component, OnInit, Inject } from '@angular/core';
import { ReportsService } from 'src/app/services/reports.service';
import { Report } from 'src/app/models/report.model';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { UserService } from 'src/app/services/user.service';
import { DealersService } from 'src/app/services/dealers.service';
import { User } from 'src/app/models/user.model';
import { plaintext } from '../../../assets/plaintext';
import { Group } from 'src/app/models/group.model';
import { DealerCountry } from 'src/app/models/dealer-country.model';

@Component({
  selector: 'app-manage-reports',
  templateUrl: './manage-reports.component.html',
  styleUrls: ['./manage-reports.component.scss']
})
export class ManageReportsComponent {

  isReportsLoading = true;
  reports: Report[] = [];
  public isPSCUser = false;
  user: User;
  plaintext = plaintext;

  constructor(private reportService: ReportsService, private router: Router, public dialog: MatDialog, private _snackBar: MatSnackBar, private clickstream: ClickStreamService, private userService: UserService) {
    this.isPSCUser = (this.userService.user.isPSC);
    this.user = this.userService.user;
    this.reportService.getReportsInPbiWorkspace().subscribe((data: Report[]) => {
      this.reports = data;
      this.isReportsLoading = false;
    })
  }

  selectedReport: Report;

  selectReport(report: Report) {
    if (report.synced == false || !report.locked) {
      // this.selectedReport = report;
      if (this.selectedReport && this.selectedReport.reportGuidPbi == report.reportGuidPbi) this.selectedReport = null;
      else this.selectedReport = report;
      this.clickstream.send('select-report', 'click', 'Manage Reports', 'Select Report', '', true);
    }
  };

  goToManageReport(report: Report) {
    if (report.synced == false) {
      this.openSyncReport(report);
    } else {
      if (this.user.businessFunction != 'dealeradmin') this.router.navigate(['/reports/manage/', report.guid]);
      else this.router.navigate(['/reports/manage/gm', report.guid])
    }
    this.clickstream.send('manage-report', 'click', 'Manage Reports', 'Select Report to Manage', '', true);
  }

  openSyncReport(report: Report) {
    const dialogRef = this.dialog.open(SyncReportDialog, {
      width: '250px',
      data: { report: this.selectedReport }
    });

    dialogRef.afterClosed().subscribe(reportResult => {
      if (reportResult) {
        // this.reports.push(result);
        this._snackBar.open('Report Synced Successfully', 'Close', { duration: 2000 });
        this.router.navigate(['/reports/manage/gm/', reportResult.guid])
      }
    }, error => {
      this._snackBar.open('Failed to sync report. Please try again later or contact support', 'Close', { duration: 2000 });
    });
  }

  reportToAdd: Report;
  openAddReport() {
    const dialogRef = this.dialog.open(AddReportDialog, {
      width: '325px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.reports.push(result);
        this._snackBar.open('Report Added Successfully', 'Close', { duration: 2000 });
        this.router.navigate(['/reports/manage/gm/', result.guid])
      }
    });

    this.clickstream.send('add-report', 'click', 'Manage Reports', 'Add Report Button', '', true);
  }
}

@Component({
  selector: 'add-report-dialog',
  templateUrl: './add-report-dialog.html',
  styleUrls: ['./add-report-dialog.scss']
})
export class AddReportDialog implements OnInit {

  public reportForm: FormGroup;

  countries: DealerCountry[];

  selectedCountries: DealerCountry[] = [];

  addError: string;

  constructor(public dialogRef: MatDialogRef<AddReportDialog>, private reportsService: ReportsService, private dealersService: DealersService) { }

  ngOnInit() {
    this.reportForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.maxLength(60)]),
      reportType: new FormControl('', [Validators.required]),
      url: new FormControl('', [Validators.required]),
      datasetUrl: new FormControl('', []),
      asms: new FormControl('', [Validators.required, Validators.maxLength(60)]),
      reportOwner: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      description: new FormControl('', [Validators.required, Validators.maxLength(500), Validators.minLength(40)]),
    });

    this.dealersService.getDealerCountries().subscribe(res => {
      this.countries = res;
    })

    this.dialogRef.updateSize("500px", "700px")
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.reportForm.controls[controlName].hasError(errorName);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public createReport = (formValue) => {
    if (this.reportForm.valid) {
      this.exectueCreateReport(formValue);
    }
  }

  private exectueCreateReport = (formValue) => {
    let report = new Report();
    report.name = formValue.name;
    report.description = formValue.description;
    report.url = formValue.url;
    report.reportType = formValue.reportType;
    report.asms = formValue.asms;
    report.countries = this.countries;
    report.reportOwnerQuery = formValue.reportOwner;
    if (report.reportType === 'pbi') report.datasetUrl = formValue.datasetUrl;
    console.log('report', report);

    this.reportsService.addReport(report).subscribe(res => {
      this.dialogRef.close(res);
    }, error => {
      console.log('addError', error);
      this.addError = error.error.message;
    })
  }

  selectCountry(country: DealerCountry) {
    this.selectedCountries.push(country);
  }

}

@Component({
  selector: 'sync-report-dialog',
  templateUrl: './sync-report-dialog.html',
  styleUrls: ['./add-report-dialog.scss']
})
export class SyncReportDialog implements OnInit {

  public reportForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<SyncReportDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private reportsService: ReportsService, private dealersService: DealersService) { }

  report: Report;

  countries: DealerCountry[];

  selectedCountries: DealerCountry[] = [];

  addError: string;

  ngOnInit() {
    this.reportForm = new FormGroup({
      reportOwner: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      description: new FormControl('', [Validators.required, Validators.maxLength(500), Validators.minLength(40)]),
      asms: new FormControl('', [Validators.required, Validators.maxLength(60)])
    });

    this.dealersService.getDealerCountries().subscribe(res => {
      this.countries = res;
    })

    this.report = this.data.report;

    this.dialogRef.updateSize("500px", "700px")
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.reportForm.controls[controlName].hasError(errorName);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public createReport = (formValue) => {
    if (this.reportForm.valid) {
      this.exectueCreateReport(formValue);
    }
  }

  private exectueCreateReport = (formValue) => {
    this.report.description = formValue.description;
    this.report.reportType = 'pbi';
    this.report.asms = formValue.asms;
    this.report.countries = this.countries;
    this.report.reportOwnerQuery = formValue.reportOwner;
    console.log('countries', this.countries);

    this.reportsService.addReport(this.report).subscribe(res => {
      this.dialogRef.close(res);
    }, error => {
      console.log('addError', error);
      this.addError = error.error.message;
    })
  }

  selectCountry(country: DealerCountry) {
    this.selectedCountries.push(country);
  }

}